import { defineMessages, useIntl } from 'react-intl';
import { getWindowLocationSearch } from '@lifeomic/phc-web-toolkit/src/redux/util/windowUtils';
import { useEffectOnce } from 'react-use';
import { useNotify } from '@lifeomic/phc-web-toolkit/src/hooks/useNotify';
import queryString from 'query-string';

const messages = defineMessages({
  successTitle: {
    id: 'phc-ui.components.common.useMarketpalceQueryParams.successTitle',
    defaultMessage: 'Your resource has successfully installed!',
  },
});

export function useProcessMarketplaceQueryParams() {
  const [addNote] = useNotify();
  const { formatMessage } = useIntl();

  useEffectOnce(() => {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    const queryParams = queryString.parse(getWindowLocationSearch());

    if (
      !queryParams.marketplaceInstall ||
      queryParams.marketplaceInstall !== 'true'
    ) {
      return;
    }

    addNote(formatMessage(messages.successTitle), 'success');
  });
}
